<!-- ================个人中心====================-->
<template>
    <div class="full-screen-container">
        <home-head />
        <div class="home-container user-center-container">
            <div class="user-center-wrapper">
                <div class="user-center-header">
                    <div class="user-center-title">个人中心</div>
                    <div class="user-center-back" @click="goBack">返回</div>
                </div>
                <div class="user-center-tabs">
                    <div class="uc-tab" :class="{ active: activeTab === 'info' }" @click="changeTab('info')">我的信息</div>
                    <div class="uc-tab" :class="{ active: activeTab === 'favorite' }" @click="changeTab('favorite')">我的收藏</div>
                </div>

                <div class="user-center-content">
                <!-- =================我的信息================= -->
                <div class="info-body" v-if="activeTab === 'info'">
                    <!--左侧：个人信息-->
                    <div class="info-left panel-box uc-scroll">
                        <div class="panel-title">个人信息</div>
                        <el-form class="info-form" ref="infoFormRef" :model="form" label-width="60px">
                            <el-form-item label="头像:">
                                <el-upload class="avatar-uploader"
                                           :action="serviceUrl + '/businessservice/user/avatar'"
                                           :show-file-list="false" :on-success="handleAvatarSuccess"
                                           :headers="{ token }" :before-upload="beforeAvatarUpload">
                                    <img v-if="form.avatar" :src="form.avatar + '?_=' + Date.now()" class="avatar" />
                                    <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="姓名:">
                                <el-input v-model="form.trueName" placeholder="最多32个字" maxlength="32" />
                            </el-form-item>
                            <el-form-item label="性别:">
                                <el-radio-group v-model="form.gender">
                                    <el-radio :label="0">男</el-radio>
                                    <el-radio :label="1">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="学段:">
                                <el-select v-model="form.periodKey" placeholder="请选择学段" @change="changePeriod">
                                    <el-option v-for="item in periodList" :key="item.dictKey"
                                               :label="item.dictValue" :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="年级:">
                                <el-select v-model="form.gradeKey" placeholder="请选择年级" @change="changeGrade">
                                    <el-option v-for="item in gradeList" :key="item.dictKey"
                                               :label="item.dictValue" :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="学科:">
                                <el-select v-model="form.subjectKeyList" multiple placeholder="请选择学科">
                                    <el-option v-for="item in subjectList" :key="item.dictKey"
                                               :label="item.dictValue" :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="机构:">
                                <el-input v-model="form.orgName" disabled placeholder="未填写" />
                            </el-form-item>
                            <el-form-item label="账号:">
                                <el-input v-model="form.username" disabled />
                            </el-form-item>
                            <div class="save-row">
                                <div class="confirm-btn" @click="submitForm">确认</div>
                            </div>
                        </el-form>
                    </div>
                    <!--右侧：荣誉-->
                    <div class="info-right">
                        <div class="panel-box honor-panel">
                            <div class="panel-title">荣誉成就</div>
                            <div class="honor-box uc-scroll">
                                <template v-if="form.honorList.length > 0">
                                    <img v-for="(item, index) in form.honorList" :key="index" class="honor-img"
                                         :src="honorImg(item)" alt="" @error="onHonorImgError" />
                                </template>
                                <el-empty v-else class="box-empty" description="暂无数据" />
                            </div>
                        </div>
                        <div class="panel-box honor-panel">
                            <div class="panel-title">荣誉证书</div>
                            <div class="honor-box uc-scroll">
                                <template v-if="certList.length > 0">
                                    <el-image v-for="(item, index) in certList" :key="index" :initial-index="index"
                                              fit="cover" :preview-src-list="certList" class="cert-img" :src="item" />
                                </template>
                                <el-empty v-else class="box-empty" description="暂无数据" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- =================我的收藏================= -->
                <div class="favorite-body panel-box" v-if="activeTab === 'favorite'">
                    <!--左侧：场馆列表-->
                    <div class="favorite-side">
                        <div v-for="museum in museumList" :key="museum.key" class="side-item"
                             :class="{ active: activeMuseum === museum.key }"
                             @click="changeMuseum(museum)">{{ museum.name }}</div>
                    </div>
                    <!--右侧：收藏内容-->
                    <div class="favorite-main">
                        <div class="favorite-sub-tabs" v-if="subTabList.length > 0">
                            <div v-for="tab in subTabList" :key="tab.key" class="sub-tab"
                                 :class="{ active: activeSubTab === tab.key }"
                                 @click="changeSubTab(tab)">{{ tab.name }}</div>
                        </div>
                        <div class="favorite-content uc-scroll" v-loading="favoriteLoading">
                            <div class="favorite-list" :class="favoriteListClass" v-if="favoriteList.length > 0">
                                <div class="favorite-card" v-for="(item, index) in favoriteList" :key="index"
                                     @click="goFavoriteDetail(item)">
                                    <div class="favorite-card-cover">
                                        <img :src="item.cover" alt="" @error="onFavoriteImgError" />
                                    </div>
                                    <div class="favorite-card-title" :title="item.title">{{ item.title }}</div>
                                </div>
                            </div>
                            <el-empty v-else class="favorite-empty" description="暂无收藏" />
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import homeHead from "@/components/common/homeHead.vue";
import { userInfo, userUpdate } from "@/api/admin/user.js";
import { userCerts } from "@/api/admin/certs.js";
import { queryDict } from "@/api/admin/dict";
import { listCollect } from "@/api/admin/collect";
import { serviceUrl } from "@/utils/global";

export default {
    name: "userCenter",
    components: { homeHead },
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            activeTab: "info",
            // 个人信息表单
            form: {
                avatar: "",
                trueName: "",
                gender: 0,
                periodKey: "",
                gradeKey: "",
                subjectKey: "",
                subjectKeyList: [],
                orgName: "",
                username: "",
                honorList: []
            },
            periodList: [],
            gradeList: [],
            subjectList: [],
            certList: [],
            // 我的收藏
            activeMuseum: "read",
            activeSubTab: "mzdd",
            favoriteList: [],
            favoriteLoading: false,
            favoriteLoaded: false,
            museumList: [
                {
                    key: "read", name: "阅读拓展馆", businessType: 1,
                    tabs: [
                        { key: "mzdd", name: "名著导读", collectType: 1 },
                        { key: "myjr", name: "美育浸润", collectType: 2 },
                        { key: "bydyw", name: "博雅大语文", collectType: 3 },
                        { key: "hydsh", name: "恒岳读书会", collectType: 4 }
                    ]
                },
                {
                    key: "intangible", name: "非遗文化馆", businessType: 3,
                    tabs: [
                        { key: "jdfjz", name: "匠•东方匠造", collectType: 1 },
                        { key: "zgjfh", name: "筑•古建风华", collectType: 2 },
                        { key: "srjyh", name: "俗•人间烟火", collectType: 3 },
                        { key: "ffygf", name: "坊•非遗工坊", collectType: 4 }
                    ]
                },
                {
                    key: "technology", name: "科学艺术馆", businessType: 2,
                    tabs: [
                        { key: "ysjmx", name: "艺•视觉美学", collectType: 1 },
                        { key: "ktsam", name: "科•探索奥秘", collectType: 2 },
                        { key: "wwmcc", name: "文•文明传承", collectType: 3 },
                        { key: "hykch", name: "恒岳科创会", collectType: 4 }
                    ]
                },
                {
                    key: "labor", name: "劳动实践馆", businessType: 4,
                    tabs: [
                        { key: "njhd", name: "年级活动", collectType: 1 },
                        { key: "sjhd", name: "四季活动", collectType: 2 }
                    ]
                },
                {
                    key: "educational", name: "研学体验馆", businessType: 5,
                    tabs: [
                        { key: "swwsl", name: "生•万物生灵", collectType: 1 },
                        { key: "stymf", name: "食•田园丰饶", collectType: 2 },
                        { key: "sttjl", name: "时•天地节律", collectType: 3 },
                        { key: "xzxyh", name: "行•知行合一", collectType: 4 }
                    ]
                },
                {
                    key: "resource", name: "优质资源", businessType: 6,
                    tabs: [
                        { key: "gspsfk", name: "高水平示范课", collectType: 1 },
                        { key: "hdkj", name: "互动课件", collectType: 2 },
                        { key: "rgzn", name: "人工智能", collectType: 3 }
                    ]
                },
                {
                    key: "excursion", name: "营在规划", businessType: 7,
                    tabs: [
                        { key: "sxrxy", name: "书香润心营", collectType: 1 },
                        { key: "kyqxy", name: "科艺启心营", collectType: 2 },
                        { key: "fyjxy", name: "非遗匠心营", collectType: 3 },
                        { key: "lqlxy", name: "劳趣砺心营", collectType: 4 },
                        { key: "yxwxy", name: "研学悟心营", collectType: 5 }
                    ]
                }
            ]
        };
    },
    computed: {
        subTabList() {
            const museum = this.museumList.find(item => item.key === this.activeMuseum);
            return museum ? museum.tabs : [];
        },
        /*收藏卡片样式：名著导读参考书目卡片、博雅大语文参考文库卡片*/
        favoriteListClass() {
            if (this.activeMuseum === "read" && this.activeSubTab === "mzdd") return "favorite-list-book";
            if (this.activeMuseum === "read" && this.activeSubTab === "bydyw") return "favorite-list-bydyw";
            return "";
        }
    },
    watch: {
        activeTab(val) {
            if (val === "favorite" && !this.favoriteLoaded) {
                this.loadFavorites();
            }
        }
    },
    created() {
        // 恢复收藏模块的tab状态（从详情页返回或刷新时保持选中）
        this.restoreFavoriteState();
        // 先加载学段年级学科字典，再加载用户信息（年级、学科下拉依赖字典）
        this.getDict().then(() => {
            this.getUserInfo();
        });
        this.getUserCerts();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        getDict() {
            return queryDict({ code: "lession_xd_nj_xk" }).then(res => {
                this.periodList = res.data.data || [];
            });
        },
        getUserInfo() {
            userInfo().then(res => {
                if (res.data.code !== 1 || !res.data.data) return;
                this.form = res.data.data;
                if (this.form.honor) {
                    this.form.honorList = this.form.honor.split(",").filter(item => item !== "");
                } else {
                    this.form.honorList = [];
                }
                if (this.form.subjectKey) {
                    this.form.subjectKeyList = this.form.subjectKey.split(",");
                } else {
                    this.form.subjectKeyList = [];
                }
                this.loadGradeList();
                this.loadSubjectList();
                this.$storage.set("userInfo", JSON.stringify(res.data.data));
            });
        },
        loadGradeList() {
            const period = this.periodList.find(item => item.dictKey === this.form.periodKey);
            this.gradeList = period ? (period.childrenList || []) : [];
        },
        loadSubjectList() {
            this.subjectList = [];
            const period = this.periodList.find(item => item.dictKey === this.form.periodKey);
            if (!period || !period.childrenList) return;
            if (this.form.gradeKey) {
                const grade = period.childrenList.find(item => item.dictKey === this.form.gradeKey);
                this.subjectList = grade ? (grade.childrenList || []) : [];
            } else {
                period.childrenList.forEach(grade => {
                    (grade.childrenList || []).forEach(subject => this.subjectList.push(subject));
                });
                this.subjectList = this.deWeight(this.subjectList);
            }
        },
        deWeight(list) {
            const temp = [];
            list.forEach(a => {
                if (temp.every(b => b.dictKey !== a.dictKey)) temp.push(a);
            });
            return temp;
        },
        changePeriod() {
            this.form.gradeKey = "";
            this.form.subjectKey = "";
            this.form.subjectKeyList = [];
            this.loadGradeList();
            this.subjectList = [];
        },
        changeGrade() {
            this.form.subjectKey = "";
            this.form.subjectKeyList = [];
            this.loadSubjectList();
        },
        getUserCerts() {
            this.certList = [];
            userCerts().then(res => {
                (res.data.data || []).forEach(e => {
                    this.certList.push(e.certUrl);
                });
            });
        },
        honorImg(item) {
            try {
                return require(`../../../assets/rycj/ry-${item}.png`);
            } catch (e) {
                return require("@/assets/image/data_empty.png");
            }
        },
        onHonorImgError(e) {
            e.target.src = require("@/assets/image/data_empty.png");
        },
        handleAvatarSuccess(response) {
            if (response.code === 1) {
                this.form.avatar = response.data;
                this.getUserInfo();
                this.$message.success("上传成功");
            } else {
                this.$message.error("上传失败");
            }
        },
        beforeAvatarUpload(rawFile) {
            if (!["image/jpeg", "image/png", "image/jpg"].includes(rawFile.type)) {
                this.$message.error("图片必须是jpeg、png、jpg格式的");
                return false;
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error("图片大小不能超过10M");
                return false;
            }
            return true;
        },
        submitForm() {
            if (this.form.subjectKeyList && this.form.subjectKeyList.length !== 0) {
                this.form.subjectKey = this.form.subjectKeyList.toString();
            } else {
                this.form.subjectKey = "";
            }
            userUpdate(this.form).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("保存成功");
                    this.getUserInfo();
                } else {
                    this.$message.error(res.data.msg || "保存失败");
                }
            });
        },
        // 我的收藏
        changeTab(tab) {
            if (this.activeTab === tab) return;
            this.activeTab = tab;
            this.syncStateToUrl();
        },
        /*从路由query恢复tab状态*/
        restoreFavoriteState() {
            const query = this.$route.query || {};
            if (query.tab === "info" || query.tab === "favorite") {
                this.activeTab = query.tab;
            }
            const museum = this.museumList.find(item => item.key === query.museum);
            if (museum) {
                this.activeMuseum = museum.key;
                const tab = (museum.tabs || []).find(item => item.key === query.subTab);
                this.activeSubTab = tab ? tab.key : (museum.tabs.length > 0 ? museum.tabs[0].key : "");
            }
        },
        /*将当前tab状态同步到路由query，保证跳详情返回后状态不变*/
        syncStateToUrl() {
            const current = this.$route.query || {};
            if (current.tab === this.activeTab && current.museum === this.activeMuseum && current.subTab === this.activeSubTab) return;
            this.$router.replace({
                path: this.$route.path,
                query: { tab: this.activeTab, museum: this.activeMuseum, subTab: this.activeSubTab }
            }).catch(() => {});
        },
        changeMuseum(museum) {
            this.activeMuseum = museum.key;
            this.activeSubTab = museum.tabs.length > 0 ? museum.tabs[0].key : "";
            this.syncStateToUrl();
            this.loadFavorites();
        },
        changeSubTab(tab) {
            if (this.activeSubTab === tab.key) return;
            this.activeSubTab = tab.key;
            this.syncStateToUrl();
            this.loadFavorites();
        },
        loadFavorites() {
            const museum = this.museumList.find(item => item.key === this.activeMuseum);
            if (!museum || !museum.businessType) return;
            const tab = (museum.tabs || []).find(item => item.key === this.activeSubTab);
            const collectType = tab ? tab.collectType : (museum.tabs.length > 0 ? museum.tabs[0].collectType : 1);
            this.favoriteLoading = true;
            listCollect({
                collectType: Number(collectType),
                businessType: Number(museum.businessType)
            }).then(res => {
                if (res.data.code === 1) {
                    let list = res.data.data || [];
                    if (!Array.isArray(list)) {
                        list = list.list || list.records || [];
                    }
                    this.favoriteList = list.map(item => ({
                        cover: item.bookCover || item.coverUrl || item.coverUrl || item.eventCover || item.activityCover || item.courseCover || item.cover || item.excursionCover,
                        title: item.bookName || item.title || item.className || item.eventTheme || item.activityName || item.courseName || item.name || item.excursionTitle,
                        relationId: item.bookId || item.videoId || item.classId || item.eventId || item.activityId || item.courseId || item.coursewareId || item.excursionId,
                    }));
                    this.favoriteLoaded = true;
                } else {
                    this.favoriteList = [];
                    this.$message.error(res.data.msg || "请求出错");
                }
            }).catch(() => {
                this.favoriteList = [];
                this.$message.error("请求出错");
            }).finally(() => {
                this.favoriteLoading = false;
            });
        },
        onFavoriteImgError(e) {
            e.target.src = require("@/assets/image/data_empty.png");
        },
        goFavoriteDetail(item) {
            const relationId = item.relationId;
            if (!relationId) {
                this.$message.warning("收藏数据异常，无法打开详情");
                return;
            }
            const museum = this.museumList.find(m => m.key === this.activeMuseum);
            if (!museum) return;
            const tab = (museum.tabs || []).find(t => t.key === this.activeSubTab);
            const collectType = tab ? tab.collectType : (museum.tabs.length > 0 ? museum.tabs[0].collectType : 1);
            const businessType = museum.businessType;
            let path = "";
            let query = {};
            switch (businessType) {
                case 1: // 阅读拓展馆
                    if (collectType === 1) {
                        path = "/museum/read/bookInfo";
                        query = { bookId: relationId };
                    } else if (collectType === 2) {
                        path = "/bymy/videoInfo";
                        query = { videoId: relationId, businessType, collectType };
                    } else if (collectType === 3) {
                        path = "/museum/read/bydywInfo";
                        query = { classId: relationId };
                    } else {
                        path = "/museum/read/bookClubInfo";
                        query = { eventId: relationId };
                    }
                    break;
                case 2: // 科学艺术馆
                case 3: // 非遗文化馆
                case 5: // 研学体验馆
                    if (collectType === 4) {
                        const map = { 2: "technology", 3: "intangible", 5: "educational" };
                        path = `/museum/${map[businessType]}/offlineInfo`;
                        query = { activityId: relationId };
                    } else {
                        path = "/bymy/videoInfo";
                        query = { videoId: relationId, businessType, collectType };
                    }
                    break;
                case 4: // 劳动实践馆
                    path = "/museum/labor/offlineInfo";
                    query = { activityId: relationId, collectType };
                    break;
                case 6: // 优质资源
                    if (collectType === 2) {
                        path = "/premium/coursewareInfo";
                        query = { coursewareId: relationId, collectType };
                    } else {
                        path = "/premium/courseInfo";
                        query = { courseId: relationId, collectType };
                    }
                    break;
                case 7: // 营在规划
                    path = "/edu/excursionInfo";
                    query = { excursionId: relationId };
                    break;
                default:
                    return;
            }
            this.$router.push({ path, query });
        }
    }
};
</script>

<style scoped lang="scss">
.user-center-container {
    height: calc(100vh - 88.5px);
    min-height: 0;
    align-items: flex-start;
    overflow: hidden;
}
.user-center-wrapper {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.user-center-content {
    flex: 1;
    min-height: 0;
}
/* 滚动条美化 */
.uc-scroll {
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #d8a0a0 #f5efef;
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    &::-webkit-scrollbar-track {
        background: #f5efef;
        border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background: #d8a0a0;
        border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #b22222;
    }
}
.user-center-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
.user-center-title {
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
}
.user-center-back {
    height: 34px;
    line-height: 34px;
    padding: 0 40px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
        background-color: #9a1b1b;
    }
}
.user-center-tabs {
    display: flex;
    gap: 20px;
    margin-bottom: 16px;
}
.uc-tab {
    width: 120px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    font-family: sans-serif;
    color: #b22222;
    background-color: #ffffff;
    border: 1px solid #b22222;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    &.active {
        color: #ffffff;
        background-color: #b22222;
    }
}
.panel-box {
    background-color: #ffffff;
    border: 1px solid #b22222;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
}
.panel-title {
    font-size: 16px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 1px;
    margin-bottom: 16px;
}
/* ============我的信息============ */
.info-body {
    display: flex;
    gap: 20px;
    align-items: stretch;
    height: 100%;
}
.info-left {
    flex: 1;
    min-width: 0;
}
.info-right {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.honor-panel {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
.info-form {
    max-width: 460px;
    margin: 0 auto;
    :deep(.el-select) {
        width: 100%;
    }
}
.save-row {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
.confirm-btn {
    width: 140px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
        background-color: #9a1b1b;
    }
}
.honor-box {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: flex-start;
}
.box-empty {
    margin: 0 auto;
}
.honor-img {
    width: 120px;
    margin: 8px;
}
.cert-img {
    width: 180px;
    height: 130px;
    margin-right: 10px;
    margin-bottom: 10px;
    object-fit: cover;
    border-radius: 4px;
}
/*头像上传*/
.avatar-uploader {
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
        object-fit: cover;
        border-radius: 4px;
    }
    :deep(.el-upload) {
        border: 1px dashed var(--el-border-color);
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        transition: var(--el-transition-duration-fast);
        &:hover {
            border-color: #b22222;
        }
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        text-align: center;
    }
}
/* ============我的收藏============ */
.favorite-body {
    display: flex;
    gap: 24px;
    height: 100%;
    padding: 20px;
}
.favorite-side {
    width: 120px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.side-item {
    height: 34px;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    font-family: sans-serif;
    color: #b22222;
    background-color: #ffffff;
    border: 1px solid #b22222;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    &.active {
        color: #ffffff;
        background-color: #b22222;
    }
}
.favorite-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}
.favorite-content {
    flex: 1;
    min-height: 0;
}
.favorite-sub-tabs {
    display: flex;
    gap: 36px;
    margin-bottom: 20px;
}
.sub-tab {
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    font-size: 14px;
    font-family: sans-serif;
    color: #b22222;
    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    &.active {
        border-color: #b22222;
        background-color: #ffffff;
    }
}
.favorite-filter {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
}
.filter-label {
    font-size: 14px;
    color: #333;
    font-family: sans-serif;
}
.filter-select {
    width: 130px;
}
.favorite-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
}
.favorite-card {
    border: 1.5px solid #b22222;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    transition: all 0.25s ease;
    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    }
}
.favorite-card-cover {
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #f3f4f6;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}
.favorite-card-title {
    width: 100%;
    min-height: 46px;
    line-height: 22px;
    padding: 10px 12px;
    font-size: 14px;
    font-weight: bold;
    color: #1f2937;
    font-family: sans-serif;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.favorite-empty {
    padding: 60px 0;
}
/*名著导读：参考 readBookPage 书目卡片*/
.favorite-list-book {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 20px;
    .favorite-card {
        height: 280px;
        border: none;
        background-color: transparent;
        align-items: center;
        &:hover {
            box-shadow: none;
        }
    }
    .favorite-card-cover {
        height: 230px;
        background-color: transparent;
        margin-bottom: 10px;
        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }
    }
    .favorite-card-title {
        min-height: 40px;
        height: 40px;
        line-height: 40px;
        padding: 0 4px;
        font-weight: normal;
        text-align: center;
        white-space: nowrap;
        display: block;
    }
}
/*博雅大语文：参考 readBydyw 文库卡片，每行五个*/
.favorite-list-bydyw {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    .favorite-card {
        width: calc(20% - 16px);
        flex-shrink: 0;
    }
    .favorite-card-cover {
        height: auto;
        img {
            width: 100%;
            height: auto;
            object-fit: contain;
        }
    }
    .favorite-card-title {
        min-height: 42px;
        line-height: 20px;
        padding: 8px 10px;
        font-weight: normal;
        text-align: center;
    }
}
@media (max-width: 1024px) {
    .user-center-content {
        overflow-y: auto;
    }
    .info-body {
        flex-direction: column;
        height: auto;
    }
    .favorite-body {
        height: auto;
        min-height: 100%;
    }
    .favorite-list {
        grid-template-columns: repeat(2, 1fr);
    }
    .favorite-list-book {
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 12px;
        .favorite-card {
            height: 240px;
        }
        .favorite-card-cover {
            height: 200px;
        }
        .favorite-card-title {
            min-height: 30px;
            height: 30px;
            line-height: 30px;
            font-size: 12px;
        }
    }
    .favorite-list-bydyw {
        .favorite-card {
            width: calc(25% - 15px);
        }
    }
}
@media (max-width: 768px) {
    .favorite-list-book {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 8px;
        .favorite-card {
            height: 200px;
        }
        .favorite-card-cover {
            height: 165px;
        }
    }
    .favorite-list-bydyw {
        .favorite-card {
            width: calc(50% - 10px);
        }
    }
}
</style>
